module.exports = __webpack_public_path__ + "static/media/InstrumentSans-Bold.d7f63974.woff2";